// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* $color-accent: #DE9204; */\n.sync-in-progress[data-v-e89ae898] {\n  margin: 0 auto;\n  padding: 2mm;\n  font-size: 10pt;\n  background-color: #6d89ae;\n}\n.hidden[data-v-e89ae898] {\n  visibility: hidden;\n}", ""]);
// Exports
module.exports = exports;
